import BaliResort1 from '../Assets/Images/bali-resort1.jpg';
import ThailandResort1 from '../Assets/Images/thailand-resort1.jpg';
import BaliResort2 from '../Assets/Images/bali-resort2.jpg';
import MalaysiaResort1 from '../Assets/Images/malaysia-resort1.jpg';
import ThailandResort2 from '../Assets/Images/thailand-resort2.jpg';
import MalaysiaResort2 from '../Assets/Images/malaysia-resort2.jpg';

let AsiaDestinationsItems = [
    {
        id: 1,
        itemImage: BaliResort1,
        itemTitle: 'Ubud Jungle Retreat',
        itemSubTitle: 'Ubud, Bali',
        itemNights: '5 nights',
        itemPrice: '£1499'
    },
    {
        id: 2,
        itemImage: ThailandResort1,
        itemTitle: 'Rainforest Wellness Resort',
        itemSubTitle: 'Chiang Mai, Thailand',
        itemNights: '7 nights',
        itemPrice: '£1399'
    },
    {
        id: 3,
        itemImage: BaliResort2,
        itemTitle: 'Clifftop Ocean Villa',
        itemSubTitle: 'Uluwatu, Bali',
        itemNights: '6 nights',
        itemPrice: '£1599'
    },
    {
        id: 4,
        itemImage: MalaysiaResort1,
        itemTitle: 'Tropical Island Hideaway',
        itemSubTitle: 'Langkawi, Malaysia',
        itemNights: '7 nights',
        itemPrice: '£1399'
    },
    {
        id: 5,
        itemImage: ThailandResort2,
        itemTitle: 'Private Beach Resort Stay',
        itemSubTitle: 'Krabi, Thailand',
        itemNights: '7 nights',
        itemPrice: '£1499'
    },
    {
        id: 6,
        itemImage: MalaysiaResort2,
        itemTitle: 'Modern City Escape Hotel',
        itemSubTitle: 'Kuala Lumpur, Malaysia',
        itemNights: '5 nights',
        itemPrice: '£999'
    }
];

export default AsiaDestinationsItems;
